import React from 'react';

import i18n from '../../i18n';

// @mui
import { FormControlLabel, Checkbox } from '@mui/material';

export default class DialogEnableField extends React.Component {
    handleCheckboxChanged(event, value) {
        this.props.onChange(event.target.id, value);
    }

    render() {
        // field, value, cache, onChange
        const { field, value } = this.props;
        let translatedName = i18n.t(`columns.${field.label}`);

        return (
            <FormControlLabel
                key={field.label}
                control={
                    <Checkbox
                        id={field.id}
                        checked={value || false}
                        onChange={(event, checked) =>
                            this.handleCheckboxChanged(event, checked)
                        }
                    />
                }
                label={translatedName}
            />
        );
    }
}
